import ArticleAsideTabsColumn from "./ArticleAsideTabsColumn";
import ArticleAsideTabsHeading from "./ArticleAsideTabsHeading"
import ArticleAsideTabsItem from "./ArticleAsideTabsItem"
import ArticleAsideTabsTab from "./ArticleAsideTabsTab"
import ArticleAsideTabsWrapper from "./ArticleAsideTabsWrapper"

export {
    ArticleAsideTabsColumn,
    ArticleAsideTabsHeading,
    ArticleAsideTabsItem,
    ArticleAsideTabsTab,
    ArticleAsideTabsWrapper,
}